/*
 *
 * AnnualStats constants
 *
 */
export const REDUCER_KEY = 'AnnualStats';
export const GET_ANNUAL_STATS = 'app/AnnualStats/GET_ANNUAL_STATS';
export const RESET_ANNUAL_STATS = 'app/AnnualStats/RESET_ANNUAL_STATS';
